import React from "react";
import { format } from "date-fns";
import { LoaderCircle } from "lucide-react";
import { useHotelSubscription } from "@/components/pages/hotels/hooks/useHotelSubscriptions";

interface HotelSubscriptionDatesCellProps {
  hotelId: string;
  type: "period" | "nextPayment";
}

function formatShortDate(value: string): string {
  return format(new Date(value), "dd.MM.yyyy");
}

function formatPeriod(
  currentPeriodStart: string | null,
  currentPeriodEnd: string | null,
): string {
  if (!currentPeriodStart || !currentPeriodEnd) {
    return "-";
  }

  return `${formatShortDate(currentPeriodStart)} - ${formatShortDate(currentPeriodEnd)}`;
}

export const HotelSubscriptionDatesCell: React.FC<
  HotelSubscriptionDatesCellProps
> = ({ hotelId, type }) => {
  const { data: subscription, isLoading } = useHotelSubscription(hotelId, true);

  if (isLoading) {
    return (
      <span className="inline-flex items-center justify-center text-muted-foreground">
        <LoaderCircle className="size-4 animate-spin" />
      </span>
    );
  }

  if (!subscription) {
    return <span className="text-xs text-muted-foreground">-</span>;
  }

  let value = "-";

  if (type === "period") {
    value = formatPeriod(
      subscription.currentPeriodStart,
      subscription.currentPeriodEnd,
    );
  } else if (subscription.nextPaymentDate) {
    value = formatShortDate(subscription.nextPaymentDate);
  }

  return (
    <span className="block whitespace-nowrap text-sm leading-5 text-zinc-900">
      {value}
    </span>
  );
};
